import {connect} from 'react-redux'
import {List, Map} from 'immutable'
import {useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'

import Closer from './core/closer/Closer'
import Modals from './core/modals/Modals'
import Button from './mui_base_components/button/Button'
import LinkButton from './mui_base_components/link_button/LinkButton'
import Logger from '../lib/NewLogger'
import MixpanelLogger from '../lib/MixpanelLogger'
import routerUtils from '../lib/routerUtils'

import {itemBySlug} from '../lib/plan_data/item'
import {findRawResourceByAttributeId} from '../lib/plan_data/userData'

import {
  accountSettingsUrl,
  goToPaymentForm,
  goToPreneedPaymentForm
} from '../lib/urlTools'

import {currentUserConfig} from '../lib/userTools'
import {isFuneralHome} from '../pro/src/lib/firmTools'

import checkMarkIcon from '../shared_assets/check-mark-green-bg.svg'
import starsIcon from '../shared_assets/five-yellow-stars.svg'

import './premiumAccessDenied.scss'

export const PremiumAccessDenied = props => {
  const query = props.location.query
  const prevPath = props.prevPath || query.prevPath
  const itemSlug = props.itemSlug || query.itemSlug

  const isFuneralHomeFreemiumClient = useMemo(() => (
    isFuneralHome(props.firm) &&
    props.userConfig?.get('freemium') &&
    props.userConfig?.get('client')
  ), [props.firm, props.userConfig])

  const headingText = useMemo(() => {
    let text = 'Give your family peace of mind'

    if (isFuneralHomeFreemiumClient) text += ', forever'

    return text
  }, [isFuneralHomeFreemiumClient])

  const pricingTextElement = useMemo(() => {
    if (isFuneralHomeFreemiumClient) {
      return (
        <>
          <div className='premium-access-denied__price-text'>
            Get lifetime access for just $299
          </div>
          <div className='premium-access-denied__price-text--last lifetime'>
            One payment, yours forever (vs. $99/year with annual)
          </div>
        </>
      )
    } else {
      return (
        <div className='premium-access-denied__price-text--last'>
          Upgrade for $99.99/year (less than $2/week)
        </div>
      )
    }
  }, [isFuneralHomeFreemiumClient])

  useEffect(() => {
    const event = {name: 'viewed_premium_modal'}

    if (itemSlug) {
      const itemName = itemBySlug({itemSlug, items: props.items}).get('name')
      event.payload = {item: itemName, wildcard: itemName}
    }

    Logger.log(event)
  }, [])

  const goToPreviousOrAccountSettingsRoute = () => {
    if (prevPath)
      return routerUtils.push(prevPath)
    else if (props.exit)
      return props.exit()

    return routerUtils.setLocation(accountSettingsUrl)
  }

  const modalCloser = () => (
    <Closer closer={goToPreviousOrAccountSettingsRoute} />
  )

  const onClick = () => {
    let new_query = `?prevPath=${prevPath || 'cm/dashboard'}`

    if (itemSlug) new_query += `&itemSlug=${itemSlug}`

    MixpanelLogger.track('click_get_premium')

    if (isFuneralHomeFreemiumClient) return goToPreneedPaymentForm(new_query)

    return goToPaymentForm(new_query)
  }

  return (
    <Modals.LinkPopUpModalLarge
      className='premium-access-denied'
      closerComponent={modalCloser}
      showModalOnMount={true}>
      <div>
        <h2 className='heading'>{headingText}</h2>
        <div className='features-list'>
          <div className='icon-text-container'>
            <img alt='' className='check-mark-icon' src={checkMarkIcon} />
            <div className='feature-text'>
              Store everything your family needs in one secure place
            </div>
          </div>
          <div className='icon-text-container'>
            <img alt='' className='check-mark-icon' src={checkMarkIcon} />
            <div className='feature-text'>
              Leave a personalized plan for each of your loved ones
            </div>
          </div>
          <div className='icon-text-container'>
            <img alt='' className='check-mark-icon' src={checkMarkIcon} />
            <div className='feature-text'>
              Share your plan and choose exactly what each person needs
            </div>
          </div>
          <div className='icon-text-container'>
            <img alt='' className='check-mark-icon' src={checkMarkIcon} />
            <div className='feature-text'>
              Get step-by-step guidance to make planning easier
            </div>
          </div>
          <div className='icon-text-container'>
            <img alt='' className='check-mark-icon' src={checkMarkIcon} />
            <div className='feature-text'>
              Import information to seamlessly set up your plan
            </div>
          </div>
        </div>
        <div className='icon-text-container trusted-by'>
          <img alt='' className='stars-icon' src={starsIcon} />
          <div className='trusted-by-text'>Trusted by 200,000+ families</div>
        </div>
        {pricingTextElement}
        <div className='action-buttons'>
          <Button onClick={onClick}>Upgrade now</Button>
          <LinkButton onClick={goToPreviousOrAccountSettingsRoute}>
            No thanks
          </LinkButton>
        </div>
      </div>
    </Modals.LinkPopUpModalLarge>
  )
}

PremiumAccessDenied.defaultProps = {
  location: {
    query: {}
  }
}

PremiumAccessDenied.propTypes = {
  exit: PropTypes.func,
  firm: PropTypes.instanceOf(Map),
  location: PropTypes.shape({
    query: PropTypes.shape({
      prevPath: PropTypes.string,
      itemSlug: PropTypes.string
    })
  }),
  prevPath: PropTypes.string,
  items: PropTypes.instanceOf(List),
  itemSlug: PropTypes.string,
  userConfig: PropTypes.instanceOf(Map)
}

const mapStateToProps = ({api, items}) => {
  const userConfig = currentUserConfig(api)
  const firm = findRawResourceByAttributeId({
    rawResource: api.firms,
    attribute: 'id',
    id: userConfig.get('firm-id')
  })

  return {firm, items, userConfig}
}
export default connect(mapStateToProps)(PremiumAccessDenied)
